import { render, staticRenderFns } from "./chateau-rayas.vue?vue&type=template&id=b7a5887a&scoped=true"
import script from "./chateau-rayas.vue?vue&type=script&lang=js"
export * from "./chateau-rayas.vue?vue&type=script&lang=js"
import style0 from "./chateau-rayas.vue?vue&type=style&index=0&id=b7a5887a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7a5887a",
  null
  
)

export default component.exports